var __TEMP__ = require('./_baseProperty.js');var baseProperty = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = asciiSize;
